import { service } from '@maia/quotation';
import { QueryOptions, queryOptions } from '@tanstack/react-query';

export type Quotation = Awaited<ReturnType<(typeof service)['getQuotation']>>;

export function getQuotationOptions(
  guid: string,
  initialData: QueryOptions<Quotation>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['quotations', guid],
    queryFn: async () => await service.getQuotation(guid),
    initialData,
  });
}
